import { type ReactNode, useEffect } from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";

import UI from "@alpacahq/ui/old";

import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import "../theme.css";
import "@alpacahq/ui/theme.css";

import AmplitudeProvider from "~/AmplitudeProvider";
import { createAppQueryClient } from "~/v2/api/queryClient";

// Built via `createAppQueryClient` for shared defaults (see queryClient.ts).
export const client = createAppQueryClient({
  defaultOptions: { queries: { staleTime: 10000 } },
});

const App = (props: { children: ReactNode }) => {
  const history = useHistory();

  // biome-ignore lint/correctness/useExhaustiveDependencies: history.location.pathname is the trigger for the page-visit analytics event; the rule wants the history object, but depending on that would dispatch a page visit on every render since history is mutable and re-created by the router.
  useEffect(() => {
    AmplitudeProvider.dispatchPageVisit();
  }, [history.location.pathname]);

  return (
    <UI.Provider history={useHistory()}>
      <QueryClientProvider client={client}>
        <div id="anchor" />
        {props.children}
      </QueryClientProvider>
    </UI.Provider>
  );
};

export default App;
